var React = require('react');

function BatteryCharging (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5002 29.3332V25.3332H19.1668L23.8335 18.6665V22.6665H27.1668L22.5002 29.3332ZM11.1668 29.3332C10.7891 29.3332 10.4724 29.2054 10.2168 28.9498C9.96127 28.6943 9.8335 28.3776 9.8335 27.9998V6.6665C9.8335 6.28873 9.96127 5.97206 10.2168 5.7165C10.4724 5.46095 10.7891 5.33317 11.1668 5.33317H13.8335V2.6665H19.1668V5.33317H21.8335C22.2113 5.33317 22.5279 5.46095 22.7835 5.7165C23.0391 5.97206 23.1668 6.28873 23.1668 6.6665V15.9998C20.9446 16.0221 19.0557 16.8054 17.5002 18.3498C15.9446 19.8943 15.1668 21.7776 15.1668 23.9998C15.1668 25.0221 15.3446 25.9887 15.7002 26.8998C16.0557 27.8109 16.5557 28.6221 17.2002 29.3332H11.1668Z","fill":"#FFB432"}));
}

BatteryCharging.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = BatteryCharging;

BatteryCharging.default = BatteryCharging;
